export const isDACHRegion = (code: string) => ['AT', 'CH', 'DE'].includes(code);
